module.exports = __webpack_public_path__ + "static/img/13.6cf5c6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/13.png
// module id = ky60
// module chunks = 0